"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getAllMessagesForRoomId = exports.getChatMessageImageLink = exports.getAllUserChatUsers = exports.sendMessage = exports.uploadImage = exports.openChatChannel = exports.openChatRoom = exports.getAllUserChatRooms = void 0;

var _now = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/date/now"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _BuildConstants = require("../../../../utils/BuildConstants");

var _RegisterInstance = _interopRequireDefault(require("../../../../KESI2/Services/RegisterInstance"));

var _HttpRequest = require("../../../../utils/HttpRequest");

var _MessagingService = _interopRequireDefault(require("../../../../KESI2/Services/MessagingService"));

var _md = _interopRequireDefault(require("md5"));

var chatUserPath = '/rest/v1/chatUser';
var chatMessagePath = '/rest/v1/chatMessage';
var chatRoomPath = '/rest/v1/chatRoom';
var imageUploadPath = '/rest/v1/image';

var getAllUserChatRooms = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
    var url, token, auth, response;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            url = _BuildConstants.CHAT_HOST + chatRoomPath;
            _context.next = 4;
            return _RegisterInstance["default"].getAccessToken('chatRoom:read');

          case 4:
            token = _context.sent;
            auth = "Bearer ".concat(token);
            _context.next = 8;
            return (0, _HttpRequest.httpGet)(url, null, null, null, null, auth);

          case 8:
            response = _context.sent;
            console.log('getAllUserChatRooms response', response);
            return _context.abrupt("return", response.data);

          case 13:
            _context.prev = 13;
            _context.t0 = _context["catch"](0);
            console.log('error getAllUserChatRooms', _context.t0);

          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 13]]);
  }));

  return function getAllUserChatRooms() {
    return _ref.apply(this, arguments);
  };
}();

exports.getAllUserChatRooms = getAllUserChatRooms;

var openChatRoom = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(user) {
    var url, token, auth, response;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            url = _BuildConstants.CHAT_HOST + chatRoomPath;
            _context2.next = 4;
            return _RegisterInstance["default"].getAccessToken('chatRoom:write');

          case 4:
            token = _context2.sent;
            auth = "Bearer ".concat(token);
            console.log('openChatRoom', auth, user);
            _context2.next = 9;
            return (0, _HttpRequest.httpPostJsonEncoded)(url, {
              subscribers: user
            }, null, null, null, auth);

          case 9:
            response = _context2.sent;
            console.log('openChatRoom response', response);
            return _context2.abrupt("return", response.data);

          case 14:
            _context2.prev = 14;
            _context2.t0 = _context2["catch"](0);
            console.log('error openChatRoom', _context2.t0);
            return _context2.abrupt("return", _promise["default"].reject(_context2.t0));

          case 18:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 14]]);
  }));

  return function openChatRoom(_x) {
    return _ref2.apply(this, arguments);
  };
}();

exports.openChatRoom = openChatRoom;

var openChatChannel = /*#__PURE__*/function () {
  var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(channelInfo, callback) {
    var chatChannel;
    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            chatChannel = _BuildConstants.ABLY_CHANNEL_PREFIX + 'chat:' + channelInfo.name;
            _context3.next = 3;
            return _MessagingService["default"].registerChannel(chatChannel, callback);

          case 3:
            _context3.next = 5;
            return _MessagingService["default"].enterPresence(chatChannel);

          case 5:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function openChatChannel(_x2, _x3) {
    return _ref3.apply(this, arguments);
  };
}();

exports.openChatChannel = openChatChannel;

var uploadImage = /*#__PURE__*/function () {
  var _ref4 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(file, roomId) {
    var url, token, auth, response;
    return _regenerator["default"].wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            url = _BuildConstants.CHAT_HOST + imageUploadPath + '/' + roomId;
            _context4.next = 4;
            return _RegisterInstance["default"].getAccessToken('chatMessage:write');

          case 4:
            token = _context4.sent;
            auth = "Bearer ".concat(token);
            _context4.next = 8;
            return (0, _HttpRequest.httpPost)(url, {
              file: file
            }, null, false, null, null, auth);

          case 8:
            response = _context4.sent;
            console.log('uploadImage response', response);

            if (!(response.status === 200)) {
              _context4.next = 14;
              break;
            }

            return _context4.abrupt("return", response.data.id);

          case 14:
            return _context4.abrupt("return", null);

          case 15:
            _context4.next = 20;
            break;

          case 17:
            _context4.prev = 17;
            _context4.t0 = _context4["catch"](0);
            console.log('error uploadImage', _context4.t0);

          case 20:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[0, 17]]);
  }));

  return function uploadImage(_x4, _x5) {
    return _ref4.apply(this, arguments);
  };
}(); // type MessageBase = {
//   id: string,
//   senderTime: number,
//   ablyTime?: number,
//   room: string,
//   sender: string,
//   receiver?: string
// }
// interface TextMessage {
//   type: 'text',
//     html: string
// }
// interface MediaMessage {
//   type: 'image' | 'video' | 'audio',
//     caption: string,
//     src: string // typical base64 for images, https, rtsp urls for other media
// }
// interface EditMessage {
//   type: 'edit',
//     patch: jsonPatch.OpPatch[]
// }


exports.uploadImage = uploadImage;

var sendMessage = /*#__PURE__*/function () {
  var _ref5 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(channelInfo, messageText, authorId, roomId, imgLink) {
    var instanceId, message, chatChannel, channel;
    return _regenerator["default"].wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;
            _context5.next = 3;
            return _RegisterInstance["default"].getApplicationInstanceId();

          case 3:
            instanceId = _context5.sent;
            message = {
              id: (0, _md["default"])(channelInfo.name + instanceId + authorId + (0, _now["default"])().toString()),
              html: messageText,
              senderTime: new Date().getTime(),
              room: roomId,
              sender: authorId,
              type: 'text'
            };

            if (imgLink) {
              message.caption = messageText;
              message.type = 'image';
              message.src = imgLink;
              delete message.html;
            }

            chatChannel = _BuildConstants.ABLY_CHANNEL_PREFIX + 'chat:' + channelInfo.name;
            _context5.next = 9;
            return _MessagingService["default"].getChannel(chatChannel);

          case 9:
            channel = _context5.sent;
            console.log('chatChannel', channel);
            _context5.next = 13;
            return _MessagingService["default"].sendMessage(channel, 'send', message);

          case 13:
            _context5.next = 18;
            break;

          case 15:
            _context5.prev = 15;
            _context5.t0 = _context5["catch"](0);
            console.log('error sending chat message', _context5.t0);

          case 18:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[0, 15]]);
  }));

  return function sendMessage(_x6, _x7, _x8, _x9, _x10) {
    return _ref5.apply(this, arguments);
  };
}();

exports.sendMessage = sendMessage;

var getAllUserChatUsers = /*#__PURE__*/function () {
  var _ref6 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6() {
    var url, token, auth, response;
    return _regenerator["default"].wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.prev = 0;
            url = _BuildConstants.CHAT_HOST + chatUserPath;
            _context6.next = 4;
            return _RegisterInstance["default"].getAccessToken('chatUser:read');

          case 4:
            token = _context6.sent;
            auth = "Bearer ".concat(token);
            _context6.next = 8;
            return (0, _HttpRequest.httpGet)(url, null, null, null, null, auth);

          case 8:
            response = _context6.sent;
            console.log('getAllUserChatUsers response', response);
            return _context6.abrupt("return", response.data);

          case 13:
            _context6.prev = 13;
            _context6.t0 = _context6["catch"](0);
            console.log('error getAllUserChatUsers', _context6.t0);

          case 16:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[0, 13]]);
  }));

  return function getAllUserChatUsers() {
    return _ref6.apply(this, arguments);
  };
}();

exports.getAllUserChatUsers = getAllUserChatUsers;

var getChatMessageImageLink = /*#__PURE__*/function () {
  var _ref7 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7(url) {
    var token, auth, response;
    return _regenerator["default"].wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.prev = 0;
            _context7.next = 3;
            return _RegisterInstance["default"].getAccessToken('chatMessage:read');

          case 3:
            token = _context7.sent;
            auth = "Bearer ".concat(token);
            _context7.next = 7;
            return (0, _HttpRequest.httpGet)(url, null, null, null, null, auth);

          case 7:
            response = _context7.sent;
            console.log('getChatMessageImageLink response', response);
            return _context7.abrupt("return", response.data);

          case 12:
            _context7.prev = 12;
            _context7.t0 = _context7["catch"](0);
            console.log('error getChatMessageImageLink', _context7.t0);

          case 15:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7, null, [[0, 12]]);
  }));

  return function getChatMessageImageLink(_x11) {
    return _ref7.apply(this, arguments);
  };
}();

exports.getChatMessageImageLink = getChatMessageImageLink;

var getAllMessagesForRoomId = /*#__PURE__*/function () {
  var _ref8 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8(roomId, fromDate, untilDate, messageCount) {
    var suffix, url, token, auth, response;
    return _regenerator["default"].wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.prev = 0;
            suffix = '';

            if (fromDate) {
              suffix = "?from=".concat(fromDate);
            }

            if (fromDate && untilDate) {
              suffix = "?from=".concat(fromDate, "&until=").concat(untilDate);
            }

            if (messageCount) {
              suffix = "?last=".concat(messageCount);
            }

            url = _BuildConstants.CHAT_HOST + chatMessagePath + '/' + roomId + suffix;
            console.log('url', url);
            _context8.next = 9;
            return _RegisterInstance["default"].getAccessToken('chatUser:read');

          case 9:
            token = _context8.sent;
            auth = "Bearer ".concat(token);
            _context8.next = 13;
            return (0, _HttpRequest.httpGet)(url, null, null, null, null, auth);

          case 13:
            response = _context8.sent;
            console.log('getAllMessagesForRoomId response', response);
            return _context8.abrupt("return", response.data);

          case 18:
            _context8.prev = 18;
            _context8.t0 = _context8["catch"](0);
            console.log('error on getAllMessagesForRoomId', _context8.t0);

          case 21:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8, null, [[0, 18]]);
  }));

  return function getAllMessagesForRoomId(_x12, _x13, _x14, _x15) {
    return _ref8.apply(this, arguments);
  };
}();

exports.getAllMessagesForRoomId = getAllMessagesForRoomId;